import { calculateTotalLoanAmount, isValueNaN } from "./utils";
const isCashOutRefinance = ({ customDependencies }) => {
  const { loanPurpose, isHELOC: isHELOC2 } = customDependencies;
  return loanPurpose !== 3 || isHELOC2;
};
const isFirstMortgage = ({ customDependencies }) => {
  const { lienPosition } = customDependencies;
  return lienPosition === 1;
};
const isHELOC = (productType, loanTerms) => {
  let isHELOC2 = false;
  const newProductType = productType?.value || productType;
  if (Array.isArray(newProductType) && loanTerms) {
    const loanIsHELOC = loanTerms.filter((elem) => newProductType?.includes(elem.value)).some((elem) => elem.heloc);
    isHELOC2 = loanIsHELOC;
  }
  return isHELOC2;
};
const isGovie = (standardProducts) => {
  return standardProducts?.includes(2) || standardProducts?.includes(3) || standardProducts?.includes(4);
};
const isIRRRL = (specialProducts) => {
  return specialProducts?.includes(55);
};
const isVA = (standardProducts) => {
  return standardProducts?.includes(3);
};
const isSubordinateHELOC = ({ customDependencies }) => {
  const { lienPosition, initialOtherHELOCDraws, initialOtherHELOCLines } = customDependencies;
  if ((!isValueNaN(initialOtherHELOCDraws) || !isValueNaN(initialOtherHELOCLines)) && lienPosition === 1) {
    return false;
  }
  return lienPosition === 1;
};
const isFirstMortgageAndHeloc = ({ customDependencies }) => {
  const { lienPosition, isHELOC: isHELOC2 } = customDependencies;
  return !(lienPosition === 1 && isHELOC2);
};
const isSecondMortgage = ({ customDependencies }) => {
  const { lienPosition } = customDependencies;
  return lienPosition === 2;
};
const getLoanAmountLabel = ({ customDependencies }) => {
  const { lienPosition, isHELOC: isHELOC2 } = customDependencies;
  let label = "Loan Amount";
  if (lienPosition === 1 && isHELOC2) {
    label = "Loan Amount (Initial Draw)";
  }
  if (lienPosition === 2) {
    label = "1st Mortgage Balance";
  }
  return label;
};
const getPropertyValueLabel = ({ customDependencies }) => {
  const { lienPosition, loanPurpose } = customDependencies;
  let label = "Property Value";
  if (lienPosition === 1 && loanPurpose === 1) {
    label = "Purchase Price/Property Value";
  }
  return label;
};
const getUpfrontGovtFeeLabel = (customDependencies, labelNum) => {
  const { standardProducts } = customDependencies.customDependencies;
  const labelMappings = {
    1: {
      2: "UFMIP Factor",
      3: "Funding Fee Factor",
      4: "Guarantee Fee Factor",
      default: "Description 1"
    },
    2: {
      2: "UFMIP Amount",
      3: "Funding Fee Amount",
      4: "Guarantee Fee Amount",
      default: "Description 2"
    },
    3: {
      2: "UFMIP Financed Amount",
      3: "Funding Fee Financed Amount",
      4: "Guarantee Fee Financed Amount",
      default: "Description 3"
    },
    4: {
      2: "UFMIP Paid in Cash",
      3: "Funding Fee Paid in Cash",
      4: "Guarantee Fee Paid in Cash",
      default: "Description 4"
    }
  };
  const labels = labelMappings[labelNum];
  const labelKey = standardProducts.find((product) => labels[product]);
  return labelKey ? labels[labelKey] : labels.default;
};
const getFloredValueTextInput = (val) => {
  const value = !["", null].includes(val) ? Math.floor(val) : "";
  return value === null || value === void 0 ? "" : value;
};
const handleTotalAmountValue = ({ customDependencies }) => {
  const { firstMortgageAmount, financedAmount, feeAmountFinanced } = customDependencies;
  const value = calculateTotalLoanAmount(
    firstMortgageAmount,
    feeAmountFinanced ?? financedAmount
  );
  return value;
};
const isHCLTVHidden = ({ customDependencies }) => {
  const { isHELOC: isHELOC2, lienPosition } = customDependencies;
  return !(isHELOC2 || lienPosition === 2);
};
const getCheckboxesSpan = (customDependencies) => {
  const isHcltvHidden = isHCLTVHidden({ customDependencies });
  const isCashoutHidden = isCashOutRefinance({ customDependencies });
  if (isHcltvHidden && isCashoutHidden) return 8;
  if (isHcltvHidden || isCashoutHidden) return 7;
  return 6;
};
const calculateGovtFeeAmount = (baseLoanAmount, govtFeeFactor) => {
  return parseFloat((baseLoanAmount * (govtFeeFactor / 100)).toFixed(2));
};
export {
  calculateGovtFeeAmount,
  getCheckboxesSpan,
  getFloredValueTextInput,
  getLoanAmountLabel,
  getPropertyValueLabel,
  getUpfrontGovtFeeLabel,
  handleTotalAmountValue,
  isCashOutRefinance,
  isFirstMortgage,
  isFirstMortgageAndHeloc,
  isGovie,
  isHCLTVHidden,
  isHELOC,
  isIRRRL,
  isSecondMortgage,
  isSubordinateHELOC,
  isVA
};
